// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1f5vc","tab":"Tabs_tab__1NB_L","tabActive":"Tabs_tabActive__3cSGG"};